import { useState } from "react";
import { FaQuestion } from "react-icons/fa";
import { RiVipCrownLine } from "react-icons/ri";
import {
  Box,
  Button,
  Divider,
  Flex,
  Icon,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  UnorderedList,
  useMediaQuery,
} from "@chakra-ui/react";
import _ from "lodash";

import { Col, Row } from "../../../../components/paljs";
import { MembershipType } from "../../../../types";

const TableDescription = () => {
  return (
    <Box fontSize={"0.9rem"} textAlign="center">
      Korzystając z oferty Klub Sportteam zostajesz członkiem naszej
      społeczności.
      <br />
      Możesz wybrać wariant członkostwa Standard lub Premium. <br />
      Warianty różnią się wysokością składki członkowskiej i wynikającymi z nich
      zniżkami na ofertę Sportteam zgodnie z Regulamin Świadczenia Usług <br />
      <Box fontSize={"md"}>
        <b>
          Jeśli wykupisz członkostwo w okresie od 1 stycznia do 31 sierpnia
          danego roku obowiązuje ono do 31 sierpnia danego roku
        </b>
        <b>
          Jeśli wykupisz członkostwo w okresie od 1 września do 31 grudnia
          danego roku obowiązuje ono do 31 sierpnia następnego roku
        </b>
      </Box>
      <br />
      <UnorderedList>
        <ListItem>Standard – opłata członkowska wynosi 50 zł</ListItem>
        <ListItem>Premium – opłata członkowska wynosi 90 zł</ListItem>
      </UnorderedList>
      <br />
    </Box>
  );
};
const TableComponent = () => {
  return (
    <Table variant="simple" size="sm">
      <Thead>
        <Tr>
          <Th>Rodzaj zniżka</Th>
          <Th>PAKIET CZŁONKOWSKI STANDARD</Th>
          <Th>PAKIET CZŁONKOWSKI PREMIUM</Th>
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td fontSize={"0.7rem"}>
            Zniżka na wyjazdy, obozy i sportowe urodziny
          </Td>
          <Td>30 zł</Td>
          <Td>50/60 zł</Td>
        </Tr>
        <Tr>
          <Td fontSize={"0.7rem"}>
            Zniżka na udział w zawodach i zakupach sprżętu sportowego
          </Td>
          <Td>5 zł</Td>
          <Td>10 zł</Td>
        </Tr>
      </Tbody>
    </Table>
  );
};

export default ({
  type,
  price,
  name,
}: {
  type?: MembershipType;
  price: number;
  name?: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isBigScreen] = useMediaQuery("(min-width: 1300px)");
  return (
    <Box mb={3}>
      <Row>
        <Col breakPoint={{ sm: isBigScreen ? 2 : 1 }}>
          <Flex align="center">
            {<Icon as={RiVipCrownLine} mr={2} />} Członkostwo
          </Flex>
        </Col>
        <Col breakPoint={{ sm: 2 }} className="elipsis">
          {_.capitalize(type)}
        </Col>

        <Col breakPoint={{ sm: isBigScreen ? 6 : 7 }}>
          <Button size="xs" onClick={() => setIsOpen(true)} mr={2}>
            {isBigScreen ? "Szczegóły" : <Icon as={FaQuestion} />}
          </Button>
          {name ? (
            <Text as="i" color={"gray.500"}>
              ({name})
            </Text>
          ) : null}
        </Col>

        <Col breakPoint={{ sm: 2 }} style={{ textAlign: "right" }}>
          {price}&nbsp;zł
        </Col>
      </Row>

      <Modal size="xl" isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Szczegóły</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <TableDescription />
            <Divider my={5} />

            <TableComponent />
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={() => setIsOpen(false)}>
              Zamknij
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};
